import { Box, Typography } from "@mui/material";
import React from "react";
import Header1 from "../components/Header1";
// import WhoProf from "../components/WhyProf/WhoProf";
// import mainLogo from "../assets/Logo/Camel Express Logo 2.jpg"
import MainSubscripe from "../components/MainSubscripe";
import Section from "../components/Ui/Section";
import { useTranslation } from "react-i18next";
import TestimonialsList from "../components/TestimonialsList";
import './About.css'
import LeaderMessage from "../components/LeaderMessage/LeaderMessage";
import image from './../assets/13.jpg'
import vid from "../assets/aboutProf.mp4"

function About() {
    const { t } = useTranslation()
    return (
        <Box>
            {/* <Box className='bgAbout'>
                <div className="overlay"></div>
                <Typography variant="h2" sx={{ zIndex: 2 }}>{t("aboutUs.aboutTheProf")}</Typography>
            </Box> */}
            <>
                <div className="header">
                    <div>
                        <Box className='videoBg' sx={{ display: 'flex', mt: { md: '15px', xs: 0 }, }} >
                            <video autoPlay={true} muted src={vid} loop width={'90%'}>
                                Your browser does not support the video tag.
                            </video>
                        </Box>
                    </div>
                </div>
            </>
            <Header1 title={t("aboutUs.title")} />
            <LeaderMessage desc={t("home.whyCamelexpressDesc")}
                img={image} />
            <Section>
                <TestimonialsList />
            </Section>
            <Section>
                <MainSubscripe />
            </Section>
        </Box>
    );
}

export default About;
